@if (parsedException) {
    @for (key of parsedExceptionKeys; track $index) {
        <div class="detail-field">
            <span class="key">{{ key }}</span>
            @if (parsedException[key]; as value) {
                @if (typeof(value) === 'string' && value.startsWith("data:image/")) {
                    <img alt="" class="value-image" [src]="value" width="300" />
                } @else {
                    <admin-linkified-text [text]="value" />
                }
            }
        </div>
    }
}
